/**
 * TODO: rename to `VERSION`
 *
 *
 * @hidden
 * @beta
 */
// This string is overwritten by prepublish script with `.version` from package.json
// The version you see here is only read in monorepo development
export const SANITY_VERSION = '0.0.0-development' as string
